import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigurationType } from '../../projects/services/project-setting.service';
@Injectable({
  providedIn: 'root'
})
export class SettingsPageService {

  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) { }



  deleteStatus(id: number) {
    return this.http.delete(environment.API_URL + `/api/configurations/status/${id}`)
  }
  deleteConfigurations(id: number) {
    return this.http.delete(environment.API_URL + `/api/configurations/configurations/${id}`)
  }

  deleteTeamRoles(id: number) {
    return this.http.delete(environment.API_URL + `/api/configurations/team-roles/${id}`)
  }


  registerStatus(status: any): any {
    return this.http.post<any>(environment.API_URL + '/api/configurations/status', status, { headers: this.headers })
  }
  registerConfigurations(config: any): any {
    return this.http.post<any>(environment.API_URL + '/api/configurations/configurations', config, { headers: this.headers })
  }

  registerteamRoles(config: any): any {
    return this.http.post<any>(environment.API_URL + '/api/configurations/team-roles', config, { headers: this.headers })
  }

  getStatus(page: number, pageSize: number) {
    return this.http.get<any>(environment.API_URL + `/api/configurations/status?pageSize=${pageSize}&page=${page}&sort=description:ASC`);
  }
  getStatusSearch(page: number, pageSize: number, field: String) {
    return this.http.get<any>(environment.API_URL + `/api/configurations/status?pageSize=${pageSize}&page=${page}&searchFields=description&search=${field}&sort=description:ASC`);
  }

  getAllPriorities(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      'query[type]': 'PRIORITY',
      pageSize,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  getAllOriginBugs(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      'query[type]': 'BUG_ORIGIN',
      pageSize: 10,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  getAllIssueBugs(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      'query[type]': 'ISSUE',
      pageSize,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  getAllEvents(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.append('query[type]', 'EVENT');
    params = params.append('query[type]', 'TASK');
    params = params.append('query[type]', 'NOTIFICATION');

    params = params.appendAll({
      pageSize,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  getAllSeverityBugs(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      'query[type]': 'SEVERITY',
      pageSize,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  getAllTeamRoles(page: number, pageSize: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      sort: 'description:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/team-roles`, { params });
  }


  updateConfiguration(config: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/configurations/configurations/${id}`, config, { headers: this.headers })
  }
  updateStatus(status: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/configurations/status/${id}`, status, { headers: this.headers })
  }
  updateFee(data: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/fees/${id}`, data, { headers: this.headers })
  }

  updateTeamRoles(roles: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/configurations/team-roles/${id}`, roles, { headers: this.headers })
  }

  getArtifactByPage(pageSize: number, page: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'id:ASC',
      pageSize,
      page,
      'query[type]': ConfigurationType.ARTIFACT
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description,clientDescription',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }


  getEventMeetingConfiguration() {
    let params = new HttpParams();
    params = params.appendAll({
      // 'query[type]': ConfigurationType.EVENT
      'query[isReunion]': true
    });

    return this.http.get<any>(environment.API_URL + `/api/configurations/configurations`, { params });
  }

  /*NOTIFICAITON EMAILS */
  getAllNotification(page: number, pageSize: number, field: string) {
    if (field && field == '') {
      return this.http.get<any>(environment.API_URL + `/api/notificationsTemplates?pageSize=${pageSize}&page=${page}&sort=id:ASC`);
    } else {
      return this.http.get<any>(environment.API_URL + `/api/notificationsTemplates?pageSize=${pageSize}&page=${page}&searchFields=subject,message,name&search=${field}&sort=id:ASC`);
    }

  }

  getNotification(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/notificationsTemplates/${id}`);
  }

  updateNotification(data: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/notificationsTemplates/${id}`, data, { headers: this.headers })
  }

  /** Timezone */
  getTimezones() {
    return this.http.get<any>(environment.API_URL + `/api/configurations/timezones`);
  }


  /*fees services */

  getFee(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/fees/${id}`);
  }

  getFeesByPage(pageSize: number, page: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'id:ASC',
      pageSize,
      page
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'name,country,countryName,value',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/fees`, { params });
  }

  registerFee(data: any): any {
    return this.http.post<any>(environment.API_URL + '/api/fees', data, { headers: this.headers })
  }

  deleteFee(id: number) {
    return this.http.delete(environment.API_URL + `/api/fees/${id}`)
  }

}
